module.exports = __webpack_public_path__ + "img/question-mark-circle.f5f723a7.svg";